// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2565":"78cb3d5b","6830":"f99297ca","7635":"4c8a2ed3"}[chunkId] + ".chunk.css";
};